export default __webpack_public_path__ + "pgnv-assets/04779d38df463e584b7c33ff51eec1de.png";